export const CATEGORY_RENAME_STARTED = 'settings/CATEGORY_RENAME_STARTED';
export const categoryRenameStarted = () => ({
  type: CATEGORY_RENAME_STARTED,
});



// WEBPACK FOOTER //
// ./app-settings/actions/category-rename-started.js